import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IProduct } from '../models/requestModels'
import { IDocList } from '../models/responseModel'

export class GetDocListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/productImage/doc-list',
      requesterInfo,
    })
  }

  public async getList(): Promise<IDocList[]> {
    return await this.getAsync<IDocList[]>()
  }
}
